import type { ReactNode } from 'react';
import type { PermissionCode } from '@oxxean/types';
import { useAuth } from '../hooks/useAuth';
import { ForbiddenNotice } from './ForbiddenNotice';

/**
 * Tercera capa de autorización en el cliente (§6 de arquitectura.md): el menú
 * oculta, esta guarda bloquea la ruta y el endpoint decide de verdad.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionCode;
  children: ReactNode;
}): JSX.Element {
  const { can } = useAuth();
  if (!can(permission)) return <ForbiddenNotice permission={permission} />;
  return <>{children}</>;
}
